<script>
import ContributorPortrait from './ContributorPortrait';
export default {
  name: 'ContentContributorsBlock',
  components: {
    ContributorPortrait
  },
  data() {
    return {
      showAll: false
    };
  },
  props: {
    data: Object,
    mode: { type: String, default: 'normal' }
  },
  methods: {
    onShowAll() {
      this.showAll = true;
    },
    itemIsVisible(index) {
      return (
        this.showMoreButtonVisible && index + 1 > this.data.number_of_items
      );
    }
  },
  computed: {
    showMoreButtonVisible() {
      return (
        this.data.number_of_items > -1 
        && this.data.contributors.length > this.data.number_of_items
        && !this.showAll
      );
    }
  }
};
</script>

<template>
  <div
    class="contributors-block"
    v-bind:class="`contributors-block--${mode}`">

    <div class="contributors-block__overview">
      <div class="contributors-block__contributors">
        <div
          class="contributors-block__contributor"
          v-bind:class="{
            'contributors-block__contributor--hidden': itemIsVisible(i),
          }"
          v-for="(contributor, i) in data.contributors"
          v-bind:key="contributor.ID">
          <contributor-portrait
            v-bind:portrait="contributor.contributor"
            v-bind:mode="mode">
          </contributor-portrait>
        </div>
      </div>
    </div>

    <div class="contributors-block__actions">
      <button
        class="contributors-block__show-more-button read-more"
        v-on:click="onShowAll"
        v-if="showMoreButtonVisible">
          {{ $t('contributorOverview.readMoreButton') }}
      </button>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.contributors-block {
  margin: 12rem 0;

  @include breakpoint('sm-down') {
    margin: 7.2rem 0;
  }
}

.contributors-block__overview {
  margin-left: 0;

  @include breakpoint('md-up') {
    margin-left: -11.6rem;
  }
}

.contributors-block--overlay .contributors-block__overview {
  margin-left: 0;
  margin-right: -11.6rem;
}

.contributors-block__contributors {
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  margin: -3.52rem -1.6rem;
}

.contributors-block__contributor {
  flex: 0 0 50%;
  width: 50%;
  box-sizing: border-box;
  padding: 3.52rem 1.6rem;
  transition: opacity 250ms;
  overflow: hidden;

  @include breakpoint('sm-down') {
    flex: 0 0 100%;
    width: 100%;
    max-width: 41.6rem;
  }
}

.contributors-block__contributor--hidden {
  height: 0;
  padding: 0;
  opacity: 0;
  pointer-events: none;
}

.contributors-block__actions {
  margin-top: 6.4rem;

  @include breakpoint('sm-down') {
    margin-top: 4rem;
  }
}

.contributors-block__show-more-button {
  font-family: $font-family;
  font-size: 1.76rem;
  font-weight: 300;
  background: transparent;
  border: none;
  outline: none;
}

.contributors-block__show-more-button:before {
  content: none;
}
</style>
